<template>
    <div class="mb-2">
        <p class="mb-3 mt-1">Add this LTI Link to your LMS to bring learners directly to this scenario.</p>
        <copy-link-input ref="lmsEmbedLink" v-model="ltiLaunchLink" class="mb-3"></copy-link-input>
        <div v-if="organizationLMSGradePassbackEnabled">
            <div class="custom-control custom-checkbox mb-2">
                <input
                    v-model="enableLTIGradePassback"
                    id="enableLTIGradePassback"
                    type="checkbox"
                    class="custom-control-input"
                />
                <label class="custom-control-label" for="enableLTIGradePassback">
                    Enable Results Sync
                    <help-text
                        content="When enabled, learner scores and completion results will be synced back to your LMS."
                        class="ml-1"
                    ></help-text>
                </label>
            </div>
            <div class="custom-control custom-checkbox mb-2" v-show="enableLTIGradePassback">
                <input
                    v-model="enableLTIManualGrading"
                    id="enableLTIManualGrading"
                    type="checkbox"
                    class="custom-control-input"
                />
                <label class="custom-control-label" for="enableLTIManualGrading">
                    Require Manual Grading in LMS
                    <help-text
                        content="When enabled, scores posted to your LMS will require intervention by a grader."
                        class="ml-1"
                    ></help-text>
                </label>
            </div>
            <div class="custom-control custom-checkbox mb-2" v-show="enableLTIGradePassback">
                <input
                    v-model="enableLTIPDFPassback"
                    id="enableLTIPDFPassback"
                    type="checkbox"
                    class="custom-control-input"
                />
                <label class="custom-control-label" for="enableLTIPDFPassback">
                    Include PDF in Results Sync <span class="badge badge-light">Canvas Only</span>
                    <help-text
                        content="When enabled, the Learner Results PDF will be posted back to your LMS along with grades."
                        class="ml-1"
                    ></help-text>
                </label>
            </div>
        </div>
        <div class="mt-4">
            <lms-instructions :default-vendor-type="organizationLmsDefaultVendorType"></lms-instructions>
        </div>
    </div>
</template>

<script>
import CopyLinkInput from "@/components/CopyLinkInput"
import HelpText from "@/components/HelpText"
import LmsInstructions from "@/components/LmsInstructions"

export default {
    name: "LtiLaunchForm",
    props: {
        caseObj: {
            type: Object,
            required: true,
        },
    },
    components: {
        CopyLinkInput,
        HelpText,
        LmsInstructions,
    },
    data() {
        return {
            enableLTIGradePassback: true,
            enableLTIPDFPassback: false,
            enableLTIManualGrading: false,
        }
    },
    watch: {
        enableLTIGradePassback: function () {
            this.reset()
        },
        enableLTIPDFPassback: function () {
            this.reset()
        },
        enableLTIManualGrading: function () {
            this.reset()
        },
    },
    computed: {
        organizationLmsDefaultVendorType() {
            return this.$store.getters.organizationDetails.lms_default_vendor_type || "d2l"
        },
        ltiLaunchLink() {
            let link = `${window.location.origin}/scenarios/?scenarioID=${this.caseObj.id}&lmsLaunchID=${this.caseObj.lms_launch_id}`
            if (this.enableLTIGradePassback && this.organizationLMSGradePassbackEnabled) {
                link += `&passbackResults=true&passbackPDF=${this.enableLTIPDFPassback}&requireManualGrading=${this.enableLTIManualGrading}`
            }
            return link
        },
        organizationLMSGradePassbackEnabled() {
            return this.$store.getters.organizationLMSGradePassbackEnabled
        },
    },
    methods: {
        // Reset the copy-state of the link.
        reset() {
            this.$refs.lmsEmbedLink.reset()
        },
        // Reset the form to its initial state.
        resetForm() {
            this.enableLTIGradePassback = true
            this.enableLTIPDFPassback = false
            this.enableLTIManualGrading = false
            this.reset()
        },
    },
}
</script>

<style>
</style>